// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__9aM2B","input":"Radio_input__5mh2q","inner":"Radio_inner__89GTE","tick":"Radio_tick__Xh9cH","text":"Radio_text__GXpcz"};